import { useCallback, useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import type { FieldValues, UseFormReturn } from 'react-hook-form';

import { useBoolean } from '../hooks';

export function resetFormState<T extends FieldValues>(form: UseFormReturn<T>, allFormValues?: T) {
  const nValues = allFormValues ?? form.getValues();
  form.reset({ ...nValues }, { keepDirty: false, keepTouched: false, keepErrors: false });
}

export function useInvalidate(dependencyArray: (string | number)[]) {
  const queryClient = useQueryClient();
  const [hasToInvalidate, setHasToInvalidate] = useBoolean(false);

  const removeQuery = useCallback(
    (depArr: (string | number)[]) => {
      console.log('Removing query', depArr);
      queryClient.removeQueries({ queryKey: depArr });
    },
    [queryClient]
  );

  useEffect(
    () => () => {
      if (hasToInvalidate) {
        setTimeout(() => {
          removeQuery(dependencyArray);
        }, 0);
      }
    },
    // !important to have this dep only to avoid unnecessary updates
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasToInvalidate]
  );

  return { setHasToInvalidate, removeQuery };
}

export function stopPropagate(callback: (e: React.FormEvent<HTMLFormElement>) => void) {
  return (e: React.FormEvent<HTMLFormElement>) => {
    e.stopPropagation();
    e.preventDefault();
    callback(e);
  };
}
